import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useTreeViewLeftPanelStyles = makeThemedStyles(
  "TreeViewLeftPanel",
  (theme) => ({
    root: {
      backgroundColor: "#F5F6F8",
      minWidth: "300px",
      padding: "10px",
      margin: "0px",
    },
  })
);
const TreeViewLeftPanel = (props: React.PropsWithChildren<{}>) => {
  const styles = useTreeViewLeftPanelStyles();
  return <div className={styles.root}>{props.children}</div>;
};

export default TreeViewLeftPanel;
